import { instafeeds, feedInit } from './instafeed';

export default function () {
  document.addEventListener('shopify:section:load', (e) => {
    const sectionId = e.detail.sectionId;

    // Is this a feed?
    const feedElement = document.getElementById(`Instafeed${sectionId}`);
    if (feedElement) {
      // Initialize it
      feedInit(sectionId, feedElement);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const sectionId = e.detail.sectionId;

    // Is this a feed?
    const feedElement = document.getElementById(`Instafeed${sectionId}`);
    if (feedElement) {
      // Has this feed already been initialized? Destroy it if so...
      if (instafeeds[sectionId]) {
        delete instafeeds[sectionId];
      }
    }
  });
}
